<template>
  <div>
    <div>
      <b-row>
        <b-col lg="5">
          <vs-card>
            <b-row>
              <b-col lg="6">
                <vs-textarea
                  size="small"
                  v-model="extensionLabel"
                  type="text"
                  class="w-full"
                  v-validate="'required'"
                  name="mainBarcode"
                />
              </b-col>
              <b-col class="pl-0 pr-0">
                <vs-input
                  size="small"
                  v-model="fontSizeLabel"
                  type="text"
                  v-validate="'required'"
                  :placeholder="$t('fontSize')"
                  name="fontSizeLabel"
                />
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="addItem()"
                  size="sm"
                >
                  <Icon
                    icon="material-symbols:save-outline"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-tabs fill>
                <b-tab
                  :title="$t('StockItem')"
                  class="vs-con-loading__container"
                  id="loading-item"
                  active
                >
                  <component
                    :is="scrollbarTag"
                    ref="scroll2"
                    class="vs-input--label scroll-area--data-list-add-new"
                    :settings="settings"
                    :key="$vs.rtl"
                  >
                    <template lang="html">
                      <div id="data-list-list-view">
                        <vs-table
                          ref="table"
                          v-model="selected"
                          search
                          :data="columnList"
                        >
                          <template slot="thead">
                            <vs-th sort-key="name"> {{ $t("Name") }} </vs-th>
                            <vs-th sort-key="name"> {{ $t("Add") }}</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <tbody>
                              <vs-tr
                                :data="tr"
                                :key="indextr"
                                v-for="(tr, indextr) in data"
                              >
                                <vs-td style="width: 10px">
                                  <p class="product-name font-medium truncate">
                                    {{ tr.name }}
                                  </p>
                                </vs-td>
                                <vs-td>
                                  <b-row>
                                    <b-col lg="2">
                                      <b-button
                                        style="padding: 1px !important"
                                        v-on:click="addItem(tr)"
                                        variant="outline-light"
                                      >
                                        <Icon
                                          icon="material-symbols-light:add"
                                          width="25"
                                          height="25"
                                          color="#28c76f"
                                        />
                                      </b-button>
                                    </b-col>
                                    <b-col lg="2">
                                      <b-button
                                        style="padding: 1px !important"
                                        v-on:click="addItem(tr, 'barcode')"
                                        variant="outline-light"
                                      >
                                        <Icon
                                          icon="ion:barcode-outline"
                                          width="25"
                                          height="25"
                                          color="#065a82"
                                        />
                                      </b-button>
                                    </b-col>
                                    <b-col>
                                      <vs-input
                                        size="small"
                                        v-model="tr.fontSize"
                                        type="text"
                                        name="corridorName"
                                        v-validate="'required'"
                                        class="w-full"
                                      />
                                    </b-col>
                                  </b-row>
                                </vs-td>
                              </vs-tr>
                            </tbody>
                          </template>
                        </vs-table>
                      </div>
                    </template>
                  </component>
                </b-tab>
                <b-tab
                  :title="$t('DepotItem')"
                  class="vs-con-loading__container"
                  id="loading-item"
                >
                  <component
                    :is="scrollbarTag"
                    ref="scroll2"
                    class="vs-input--label scroll-area--data-list-add-new"
                    :settings="settings"
                    :key="$vs.rtl"
                  >
                    <template lang="html">
                      <div id="data-list-list-view">
                        <vs-table
                          ref="table"
                          v-model="selectedShelf"
                          search
                          :data="columnListShelf"
                        >
                          <template slot="thead">
                            <vs-th sort-key="name"> {{ $t("Name") }} </vs-th>
                            <vs-th sort-key="name"> {{ $t("Add") }}</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <tbody>
                              <vs-tr
                                :data="tr"
                                :key="indextr"
                                v-for="(tr, indextr) in data"
                              >
                                <vs-td style="width: 10px">
                                  <p class="product-name font-medium truncate">
                                    {{ tr.name }}
                                  </p>
                                </vs-td>
                                <vs-td>
                                  <b-row>
                                    <b-col lg="2">
                                      <b-button
                                        style="padding: 1px !important"
                                        v-on:click="addItem(tr)"
                                        variant="outline-light"
                                      >
                                        <Icon
                                          icon="material-symbols-light:add"
                                          width="25"
                                          height="25"
                                          color="#28c76f"
                                        />
                                      </b-button>
                                    </b-col>
                                    <b-col lg="2">
                                      <b-button
                                        style="padding: 1px !important"
                                        v-on:click="addItem(tr, 'barcode')"
                                        variant="outline-light"
                                      >
                                        <Icon
                                          icon="ion:barcode-outline"
                                          width="25"
                                          height="25"
                                          color="#065a82"
                                        />
                                      </b-button>
                                    </b-col>
                                    <b-col>
                                      <vs-input
                                        size="small"
                                        v-model="tr.fontSize"
                                        type="text"
                                        name="corridorName"
                                        v-validate="'required'"
                                        class="w-full"
                                      />
                                    </b-col>
                                  </b-row>
                                </vs-td>
                              </vs-tr>
                            </tbody>
                          </template>
                        </vs-table>
                      </div>
                    </template>
                  </component>
                </b-tab>
                <b-tab title="Element">
                  <component
                    :is="scrollbarTag"
                    ref="scroll2"
                    class="vs-input--label scroll-area--data-list-add-new mt-15"
                    :settings="settings"
                    :key="$vs.rtl"
                  >
                    <b-row style="margin-top: 15px">
                      <b-col lg="3" v-on:click="addLine('horizontalLine', 12, 1)">
                        <vs-card>
                          <Icon icon="vaadin:line-h" style="width: 100%; height: 100%" />
                        </vs-card>
                      </b-col>
                      <b-col lg="3" v-on:click="addLine('verticalLine', 1, 12)">
                        <vs-card>
                          <Icon icon="vaadin:line-v" style="width: 100%; height: 100%" />
                        </vs-card>
                      </b-col>
                      <b-col lg="3" v-on:click="addBarcode('barcode', 12, 4)">
                        <vs-card>
                          <Icon
                            icon="ion:barcode-outline"
                            style="width: 100%; height: 100%"
                          />{{ $t("Barcode") }}
                        </vs-card>
                      </b-col>
                      <b-col
                        lg="3"
                        v-on:click="
                          addItem({ name: 'serialNo', fontSize: 16 }, 'barcode')
                        "
                      >
                        <vs-card>
                          <Icon
                            icon="ion:barcode-outline"
                            style="width: 100%; height: 100%"
                          />{{ $t("SerialNumber") }}
                        </vs-card>
                      </b-col>
                      <!--  
											<b-col lg="3" v-on:click="addLine('imageLine', 1, 12)">
                        <vs-card>
                          <Icon icon="clarity:picture-line" style="width: 100%; height: 100%" />
                        </vs-card>
                      </b-col>-->
                    </b-row>
                    <b-row>
                      <b-col
                        lg="3"
                        v-on:click="
                          addItem({ name: 'SupplierCode', fontSize: 16 }, 'barcode')
                        "
                      >
                        <vs-card>
                          <Icon
                            icon="ion:barcode-outline"
                            style="width: 100%; height: 100%"
                          />{{ $t("SupplierCode") }}
                        </vs-card>
                      </b-col>
                      <b-col
                        lg="3"
                        v-on:click="
                          addItem({ name: 'SupplierName', fontSize: 16 }, 'barcode')
                        "
                      >
                        <vs-card>
                          <Icon
                            icon="ion:barcode-outline"
                            style="width: 100%; height: 100%"
                          />{{ $t("SupplierName") }}
                        </vs-card>
                      </b-col>
                    </b-row>
                  </component>
                </b-tab>
              </b-tabs>
            </b-row>
          </vs-card>
          <vs-card>
            <v-select
              color="danger"
              v-model="template"
              :options="templateListOption"
              size="small"
              autocomplete
              label="name"
              ref="selectElement"
              name="template"
              v-validate="'required'"
              :disabled="isUpdate"
            >
            </v-select>

            <span class="text-danger text-sm" v-show="errors.has('template')">{{
              errors.first("template")
            }}</span>
            <b-button
              class="bg-primary mt-3"
              style="border-color: white; width: 100%"
              v-on:click="isSidebarActiveProcess = true"
            >
              <Icon icon="fluent-mdl2:completed" width="20" height="20" />
              {{ $t("Save") }}</b-button
            >
            <b-button
              class="bg-danger"
              style="border-color: white; width: 100%"
              v-on:click="deleteAllList()"
            >
              <Icon icon="ic:baseline-remove-circle" width="20" height="20" />
              {{ $t("Delete") }}</b-button
            >
            <b-button
              class="bg-warning mb-5"
              style="border-color: white; width: 100%"
              v-on:click="printBarcode()"
            >
              <Icon icon="material-symbols:print-outline" width="20" height="20" />
              {{ $t("Print") }}</b-button
            >
          </vs-card>
        </b-col>
        <b-col>
          <vs-card>
            <b-row>
              <b-col>
                <b-row v-if="ROLE != 'Company'">
                  <b-col cols="3" align-self="center">
                    <b-form-group
                      :label="'* ' + $t('Customer')"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="9">
                    <v-select
                      color="danger"
                      v-model="customer"
                      :options="customer_choices"
                      size="small"
                      label="name"
                      autocomplete
                      ref="selectElement"
                      name="customer"
                      v-validate="'required'"
                      @input="getStockWithBarcodesList"
                      :disabled="isUpdate"
                    >
                    </v-select>

                    <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                      errors.first("customer")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="3">
                <b-row>
                  <b-col cols="5" align-self="center" style="padding: 0px">
                    <b-form-group
                      :label="$t('Width')"
                      class="vs-input--label pr-0 mr-0"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <vs-input
                      size="small"
                      v-model="width"
                      type="number"
                      class="w-full"
                      name="width"
                      v-validate="'required'"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('width')">{{
                      errors.first("width")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="3">
                <b-row>
                  <b-col cols="5" align-self="center" style="padding: 0px">
                    <b-form-group
                      :label="$t('Height')"
                      class="vs-input--label pr-0 mr-0"
                      label-for="h-first-name"
                      style="font-weight: 600"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="7">
                    <vs-input
                      size="small"
                      v-model="height"
                      type="number"
                      class="w-full"
                      name="height"
                      v-validate="'required'"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('height')">{{
                      errors.first("height")
                    }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </vs-card>
          <div ref="printProductBarcode"> 
            <vs-card :style="'width: ' + width + 'mm; height: ' + height + 'mm'">
              <grid-layout
                :layout="layout"
                :col-num="colNum"
                :row-height="5"
                :is-draggable="true"
                :is-resizable="true"
                :margin="[10, 10]"
                @layout-updated="layoutUpdatedEvent"
              >
                <grid-item
                  v-for="(item, index) in layout"
                  :key="item.i + '-' + item.x"
                  :i="item.i"
                  :x="item.x"
                  :y="item.y"
                  :w="item.w"
                  :h="item.h"
                  @resize="resizeEvent"
                  @container-resized="containerResizedEvent"
                >
                  <div
                    v-if="item.barcode"
                    style="height: 100%"
                    @click="setBarcodeValue(item, index)"
                  >
                    <barcode
                      :value="item.barcode"
                      format="CODE128"
                      :text-options="{ fontSize: 1000 }"
                      :width="item.barcodeWidth"
                      :height="item.barcodeHeight" 
                    />
                  </div>
                  <div v-else-if="item.barcodeDynamic" style="height: 100%">
                    <barcode
                      :value="item.barcodeDynamic"
                      format="CODE128"
                      :text-options="{ fontSize: 1000 }"
                      :width="item.barcodeWidth"
                      :height="item.barcodeHeight" 
                    />
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.label"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    {{ item.label }}
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.element == 'horizontalLine'"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    <hr style="width: 100%; height: 3px; border-top: 2px solid #000" />
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else-if="item.element == 'verticalLine'"
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    <div
                      class="vertical-line"
                      style="
                        width: 2px;
                        height: 100%;
                        background-color: #000;
                        margin: 0 auto;
                      "
                    ></div>
                  </div>
                  <div
                    class="grid-item-content"
                    style="text-align: center"
                    v-else
                    :style="{ fontSize: item.fontSize + 'px' }"
                  >
                    {{ item.item }}
                  </div>
                  <span class="remove" @click="removeItem(item.i)">
                    <Icon
                      icon="material-symbols:close"
                      width="20"
                      height="20"
                      color="#fe6d73"
                    />
                  </span>
                  <!--
                  <span class="edit" @click="editItem(item, index)">
                    <Icon icon="iconoir:edit" width="20" height="20" color="#065a82" />
                  </span>-->
                </grid-item>
              </grid-layout>
            </vs-card>
          </div>
        </b-col>
      </b-row>
      <vs-prompt
        :title="$t('Warning')"
        :acceptText="$t('Submit')"
        :cancelText="$t('Cancel')"
        @accept="completeProcess"
        :active.sync="isSidebarActiveProcess"
        color="primary"
      >
        <div style="text-align: center" class="con-exemple-prompt">
          <span>
            <b-row style="margin-top: 15px">
              <b-col cols="12" align-self="center">
                <h6>{{ $t("DoConfirm") }}</h6>
              </b-col>
            </b-row>
          </span>
        </div>
      </vs-prompt>
      <vs-prompt
        :title="$t('Warning')"
        :acceptText="$t('Submit')"
        :cancelText="$t('Cancel')"
        @accept="deleteProcess"
        :active.sync="deleteWarningPromptValid"
        color="danger"
      >
        <div style="text-align: center" class="con-exemple-prompt">
          <span>
            <b-row style="margin-top: 15px">
              <b-col cols="12" align-self="center">
                <h6>{{ $t("DoConfirm") }}</h6>
              </b-col>
            </b-row>
          </span>
        </div>
      </vs-prompt>
      <vs-popup
        class="holamundo"
        :title="$t('PrintBroductBarcode')"
        :active.sync="editItemPopup"
        @close="closeEditPopup"
        @cancel="closeEditPopup"
        v-if="layout[editLayoutItemIndex]"
      >
        <b-row>
          <quill-editor ref="myQuillEditor" v-model="content" :options="editorOption">
            <div id="toolbar" slot="toolbar">
              <!-- Add a bold button -->
              <button class="ql-bold">Bold</button>
              <button class="ql-italic">Italic</button>

              <!-- Add font size dropdown -->
              <select class="ql-size">
                <option value="small"></option>

                <!-- Note a missing, thus falsy value, is used to reset to default -->
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>

              <select class="ql-font">
                <option selected="selected"></option>
                <option value="serif"></option>
                <option value="monospace"></option>
              </select>

              <!-- Add subscript and superscript buttons -->
              <button class="ql-script" value="sub"></button>
              <button class="ql-script" value="super"></button>

              <!-- You can also add your own -->
              <button style="width: auto" @click="customButtonClick">Click here</button>
            </div>
          </quill-editor>
        </b-row>
      </vs-popup>
      <vs-prompt
        :title="$t('Warning')"
        :acceptText="$t('Submit')"
        :cancelText="$t('Cancel')"
        @accept="changeBarcodeWidth"
        :active.sync="isSidebarActiveProcessFBarcode"
        color="primary"
      >
        <div style="text-align: center" class="con-exemple-prompt">
          <span>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('BarcodeWidth')"
                  class="vs-input--label pr-0 mr-0"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="barcodeWidth"
                  type="number"
                  class="w-full"
                  name="width"
                  v-validate="'required'"
                  placeholder="Genişlik girin"
                />
                <span class="text-danger text-sm" v-show="errors.has('width')">{{
                  errors.first("width")
                }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('BarcodeHeight')"
                  class="vs-input--label pr-0 mr-0"
                  label-for="h-first-name"
                  style="font-weight: 600"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="barcodeHeight"
                  type="number"
                  class="w-full"
                  name="width"
                  v-validate="'required'"
                  placeholder="Genişlik girin"
                />
                <span class="text-danger text-sm" v-show="errors.has('width')">{{
                  errors.first("width")
                }}</span>
              </b-col>
            </b-row>
          </span>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Icon } from "@iconify/vue2";
import Barcode from "vue-barcode";
import { uuid } from "vue-uuid";
import vSelect from "vue-select";
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Prism from "vue-prism-component";

export default {
  components: {
    quillEditor,
    Prism,
    vSelect,
    uuid,
    Barcode,
    Icon,
    GridLayout,
    GridItem,
    VuePerfectScrollbar,
  },
  data() {
    return {
      barcodeWidth: 0,
      barcodeHeight: 0,
      isSidebarActiveProcessFBarcode: false,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      content: "",
      editItemPopup: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      deleteWarningPromptValid: false,
      isSidebarActiveProcess: false,
      extensionLabel: "",
      fontSizeLabel: "",
      selected: "",
      selectedShelf: "",
      columnList: [],
      columnListShelf: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      width: 40.0,
      height: 30.0,
      layout: [],
      layoutIndex: 0,
      colNum: 12,
      customer_choices: [],
      customer: "",
      template: "",
      editLayoutItemIndex: "",
      editLayoutItem: [],
      isUpdate: false,
      TemplateDefinitionId: "",
      CompanyId: "",
      CompanyName: "",
      templateListOption: [],
      barcodeIndex: null,
    };
  },
  mounted() {
    if (this.$route.params.data) {
      this.isUpdate = true;
      let layoutLc = JSON.parse(this.$route.params.data); 
      this.layout = layoutLc.TemplateDefinitionValue;
      this.layout.forEach((val, ind) => {
        this.layout[ind].static = false;
      });
      this.width = layoutLc.TemplateDefinitionWith;
      this.height = layoutLc.TemplateDefinitionHeight;
      this.TemplateDefinitionId = layoutLc.TemplateDefinitionId;
      this.CompanyId = layoutLc.CompanyId;
      this.CompanyName = layoutLc.CompanyName;

      this.customer = { value: this.CompanyId, name: this.CompanyName };
      this.getStockWithBarcodesList();
    }
    if (this.$route.params.copy) {
      this.customer = { value: this.CompanyId, name: this.CompanyName };
      this.getStockWithBarcodesList();
      this.isUpdate = false;
    }

    this.layoutIndex = this.layout.length;
    this.getStockList();
    if (this.shelfAll.length == 0) this.filterShelf(); 
    this.getShelfList();
    this.getCustomerList();
    this.getTemplateList();
  },
  methods: {
    changeBarcodeWidth() {
			console.log(this.layout[this.barcodeIndex])
      this.layout[this.barcodeIndex].barcodeWidth = this.barcodeWidth;
      this.layout[this.barcodeIndex].barcodeHeight = this.barcodeHeight;
    },
    setBarcodeValue(item, index) {
      this.barcodeWidth = this.layout[index].barcodeWidth;
      this.barcodeHeight = this.layout[index].barcodeHeight;

      this.barcodeIndex = index;
      this.isSidebarActiveProcessFBarcode = true;
    },
    layoutUpdatedEvent(newLayout) {},
    containerResizedEvent(i, newH, newW, newHPx, newWPx) {
      this.layout[i].Wpx = newWPx;
      this.layout[i].Hpx = newHPx;
    },
    resizeEvent(i, newH, newW, newHPx, newWPx) {
      this.layout[i].Wpx = newWPx;
      this.layout[i].Hpx = newHPx;
    },
    addBarcode(element, w, h) {
      let layoutItem = {
        x: (this.layout.length * 2) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12),
        w: w,
        h: h,
        i: this.layoutIndex,
        barcodeDynamic: "barcodeDynamic" + this.layoutIndex,
        fontSize: "25",
        value: element,
      };
      this.layout.push(layoutItem);
      this.layoutIndex++;
    },
    addLine(element, w, h) {
      let layoutItem = {
        x: (this.layout.length * 2) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12),
        w: w,
        h: h,
        i: this.layoutIndex,
        element: element,
        fontSize: "16",
      };

      this.layout.push(layoutItem);
      this.layoutIndex++;
    },

    customButtonClick(event) {
      quill.setText(this.layout[this.editLayoutItemIndex].item);

      const inputEle = document.getElementsByTagName("h2");
      this.layout[this.editLayoutItemIndex].content = this.content.replace('"', "'");
    },
    closeEditPopup() {},
    editItem(item, index) {
      this.editLayoutItem = item;
      this.editLayoutItemIndex = index;
      this.editItemPopup = true;
      if (this.layout[index].contentBarcode)
        this.content = this.layout[index].contentBarcode;
      else if (this.layout[index].contentItem)
        this.content = this.layout[index].contentItem;
      else if (this.layout[index].contentLabel)
        this.content = this.layout[index].contentLabel;
    },
    printBarcode() {
      const printContents = this.$refs.printProductBarcode.innerHTML;
      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write(`
      <html>
        <head>
          <title>Etiket Yazdır</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
              }
              .vs-card {
                width: ${this.width}mm;
                height: ${this.height}mm;
                margin: 0 auto;
                page-break-inside: avoid;
              }
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    deleteProcess() {
      this.layout = [];
    },
    deleteAllList() {
      this.deleteWarningPromptValid = true;
    },
    completeProcess() {
      const vs = this.$vs;

      var createdId = uuid.v4();
      let methodLc = "addTemplateDefinition";
      let obj = {
        templateDefinitionId: createdId,
        templateDefinitionName: this.template.value,
        templateDefinitionValue: JSON.stringify(this.layout),
        templateDefinitionWith: this.width,
        templateDefinitionHeight: this.height,
        companyName: this.customer.name,
        companyId:
          this.ROLE == "Company"
            ? this.$store.state.AppActiveUser.companyid
            : this.customer.value,
      };
      if (this.isUpdate == true) {
        methodLc = "updateTemplates";
        obj = {
          templateDefinitionId: this.TemplateDefinitionId,
          templateDefinitionName: this.template.value,
          templateDefinitionValue: JSON.stringify(this.layout),
          templateDefinitionWith: this.width,
          templateDefinitionHeight: this.height,
          companyName: this.CompanyName,
          companyId: this.CompanyId,
        };
      }
      this.$store.dispatch("template/" + methodLc, obj).then((response) => {
        try {
          if (response.status == 200) {
            vs.notify({
              text: response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        } catch (error) {
          vs.notify({
            text: error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        }
      });
    },

    addItem(item, barcode) { 
      let layoutItem = {
        x: (this.layout.length * 2) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12),
        w: 12,
        h: barcode === "barcode" ? 4 : 1,
        i: this.layoutIndex,
        barcodeWidth: 1,
        barcodeHeight: 30,
        value: item.name,
      };
      if (item) {
        if (barcode === "barcode") {
          layoutItem.barcode = item.name;
          layoutItem.contentBarcode = "";
          layoutItem.fontSize = "16";
        } else {
          layoutItem.item = item.name;
          layoutItem.contentItem = "";
          layoutItem.fontSize = item.fontSize;
        }
      } else {
        layoutItem.label = this.extensionLabel;
        layoutItem.contentLabel = "";
        layoutItem.fontSize = this.fontSizeLabel;
      }
      this.layout.push(layoutItem);
      this.layoutIndex++;
    },
    removeItem(val) {
      const index = this.layout.map((item) => item.i).indexOf(val);
      this.layout.splice(index, 1);
    },
    getStockList() {
      const vs = this.$vs;
      this.stockList = [];
      this.stockColumns = [];
      //  this.layout = [];
      this.stockList = this.stock;
      this.stockListFiltered = this.stock;
      if (this.stockList.length > 0) {
        let columnsLc = Object.keys(this.stockList[0]);
        let columnsLc2 = Object.keys(this.stockList[0].Stock);

        this.columnList = [];
        this.columnList.push({ name: "Date", fontSize: "16" });
        columnsLc.forEach((val, ind) => {
          if (!val.includes("Id")) {
            this.columnList.push({ name: val, fontSize: "16" });
          }
        });
        columnsLc2.forEach((val, ind) => {
          if (!val.includes("Id")) {
            this.columnList.push({ name: val, fontSize: "16" });
          }
        });
        if (!this.isUpdate) this.addItem("StockName");
      }
    },
    filterShelf() {
      const vs = this.$vs;
      this.tableTitle = "ShelfList";

      this.$store
        .dispatch("storehouse/listShelf")
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getShelfList() {
      const vs = this.$vs;
      this.shelfAllList = [];
      this.shelfAllColumns = [];
      //  this.layout = [];
      this.shelfAllList = this.shelfAll;
      this.shelfAllListFiltered = this.shelfAll;
      if (this.shelfAllList.length > 0) {
        let columnsLc = Object.keys(this.shelfAllList[0]);

        this.columnListShelf = [];
        this.columnListShelf.push({ name: "Date", fontSize: "16" });
        columnsLc.forEach((val, ind) => {
          if (!val.includes("Id")) {
            this.columnListShelf.push({ name: val, fontSize: "16" });
          }
        });

        // if (!this.isUpdate) this.addItem("StockName");
      }
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.company;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    getTemplateList() {
      this.templateListOption = [];
      this.barcodePrintingModules.forEach((val, index) => {
        this.templateListOption.push({ name: this.$t(val), value: val });
      });
    },
    getStockWithBarcodesList() {
      const vs = this.$vs;
      let type = "material";
      vs.loading({
        container: `#loading-item`,
        type,
        scale: 0.75,
      });
      this.$store
        .dispatch("stock/listStockWithBarcodes", this.customer.value)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-item > .con-vs-loading");
            }, 1000);
            try {
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-item > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-item > .con-vs-loading");
          }, 1000);
        });
    },
  },
  computed: {
    barcodePrintingModules: {
      get() {
        return this.$store.state.template.BarcodePrintingModules;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stock: {
      get() {
        return this.$store.state.stock.StockWithBarcodes;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    shelfAll: {
      get() {
        return this.$store.state.storehouse.ShelfAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  watch: {
    shelfAll(val) {
      if (val.length > 0) {
        this.getShelfList();
      }
      return val;
    },
    barcodePrintingModules(val) {
      this.getTemplateList();
      return val;
    },
    company(val) {
      this.getCustomerList();
      return val;
    },
    stock(val) {
      this.getStockList();
      return val;
    },
  },
};
</script>

<style lang="scss">
.grid-item-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: black;
}
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}
.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.layoutJSON {
  background: #ddd;
  margin-top: 10px;
  padding: 10px;
}

.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}

/*************************************/

.edit {
  position: absolute;
  right: 25px;
  top: 0;
  cursor: pointer;
}
.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  cursor: pointer;
}
.vue-barcode-element {
  height: 100%;
  width: 100%;
}
.vertical-line {
  width: 2px;
  height: 100%;
  background-color: #000;
  margin: 0 auto;
}
@media print {
  .vertical-line {
    width: 2px;
    height: 100%;
    background-color: #000;
    margin: 0 auto;
  }
}
</style>
